<formly-form [model]="data" [fields]="fields" [form]="form"></formly-form>
<mat-dialog-actions align="end">
    <button mat-stroked-button color="warn" (click)="close()">Cancel</button>
    <button mat-stroked-button color="accent" [disabled]="form.invalid || form.pristine" (click)="save()">Save</button>
</mat-dialog-actions>